import React, { type ComponentPropsWithoutRef } from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { useIntl } from '@atlassian/jira-intl';
import { JiraSpotlight } from '@atlassian/jira-spotlight/src/ui/jira-spotlight.tsx';
import PopupImage from './assets/popup-image.svg';
import messages from './messages';

type SpotlightProps = Pick<
	ComponentPropsWithoutRef<typeof JiraSpotlight>,
	| 'pulse'
	| 'target'
	| 'targetNode'
	| 'targetBgColor'
	| 'targetOnClick'
	| 'targetRadius'
	| 'targetReplacement'
	| 'dialogPlacement'
	| 'testId'
>;

interface Props extends SpotlightProps {
	onLearnMore?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	onDismiss?: (e: React.MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
}

export function CompassComponentsPopup({ onLearnMore, onDismiss, testId, ...forwardProps }: Props) {
	const { formatMessage } = useIntl();

	const learnMoreTestId = testId && `${testId}-learn-more`;
	const dismissTestId = testId && `${testId}-dismiss`;

	return (
		<JiraSpotlight
			{...forwardProps}
			image={PopupImage}
			dialogWidth={320}
			actions={[
				{
					text: formatMessage(messages.learnMore),
					onClick: onLearnMore,
					testId: learnMoreTestId,
				},
				{
					appearance: 'subtle-link',
					text: formatMessage(messages.dismiss),
					onClick: onDismiss,
					testId: dismissTestId,
				},
			]}
			heading={formatMessage(messages.heading)}
			testId={testId}
			messageId="project-directories.components.compass-components-spotlight.compass-components-popup.jira-spotlight"
			messageType="engagement"
		>
			{formatMessage(messages.summary)}
		</JiraSpotlight>
	);
}
